








import {defineComponent} from '@vue/composition-api'

export default defineComponent({
    name: "TitleAtom",
    props: {
        title: {
            type: String,
            required: true,
            default: ""
        },
        titleClass: {
            type: String,
            required: true,
            default: ""
        },
        href: {
            type: String,
            required: false,
            default: null
        },
        target: {
            type: String,
            required: false,
            default: null
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true
        }
    }
})
